<template>
  <main>
    <div v-if="!isArticel.status">
      <div v-if="meanCenterObj.tabName == ''" class="main">
        <div
          v-for="item in list"
          :key="item.id"
          :class="item.is_right ? 'imgR' : 'imgL'"
        >
          <img :src="item.image" alt="" />
          <div>
            <p>{{ item.summary }}</p>
            <el-button
              type="primary"
              @click="toArticel({ cate: item.cate_id, id: item.id })"
              >了解详情
              <span
                class="iconfont icon-fanhuizuojiantouxiangzuoshangyibuxianxing"
              ></span>
            </el-button>
          </div>
        </div>
      </div>
      <technology-p v-else />
    </div>
    <articel v-else />
  </main>
</template>

<script>
import { mapGetters, mapActions, mapGettersns } from "vuex";
import articel from "../components/common/articel.vue";
export default {
  components: { articel },
  name: "Product",
  data() {
    return {
      list: [],
      info: {},
      params: {
        page: 1,
        limit: 10,
      },
      scroll: {
        loadState: "More", //loading,oMore
        maxS: 0, //最大滚动
        nowS: 0, //当前滚动
      },
    };
  },
  computed: {
    ...mapGetters(["meanCenterObj", "pageCate", "isArticel"]),
  },
  created() {
    this.getList();
  },
  mounted() {
    if (this.pageCate.cate.en_name == "Product") {
      window.addEventListener("scroll", this.getScroll);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
  methods: {
    ...mapActions(["getCate", "toArticel"]),
    getList() {
      if (this.pageCate.list.length < this.params.limit) {
        this.scroll.loadState = "noMore";
      }
      Object.assign(this.info, this.pageCate);
      this.list.push(...this.pageCate.list);
    },
    loadMore() {
      console.log("加载更多");
      this.params.page++;
      this.scroll.loadState = "loading";
      this.$api.CATE(this.info.cate.id, this.params).then((info) => {
        // this.$public_data.imageURL(info.list).then((img) => {
          // this.info
          let list = info.list;
          if (list.length < this.params.limit) {
            this.scroll.loadState = "noMore";
          }
          this.list.push(...info.list);
        // });
      });
    },
    getScroll() {
      let dom = document.getElementsByClassName("imgL")[0];
      let maxS = dom.offsetHeight * this.list.length - dom.offsetHeight;
      Object.assign(this.scroll, { maxS: maxS, domH: dom.offsetHeight });
      let nowS =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scroll.loadState == "More") {
        if (!!nowS && nowS >= this.scroll.maxS) {
          this.loadMore();
        }
      }
    },
  },
};
</script>

<style scoped lang='less'>
main {
  .main {
    > div {
      position: relative;
      padding:1.04vw;
      font-size:  0.93vw;
      box-shadow: 0px 0px 1vw 1vw #f3f3f3;
      margin: 2.08vw auto;
      display: flex;
      justify-content: space-between;
      flex-flow: row nowrap;
      align-items: center;
      // .el-button {
      //   position: absolute;
      // }
      .el-image{
        background: #f00;
      }
      > div {
        width: 53.02vw;
        position: relative;
        // background: #f00;
        display: flex;
        justify-content: space-between;
        flex-flow: column nowrap;
        padding-bottom: 3.541vw;
        >p{
          font-size:1vw;
          font-weight: bold;
          line-height: 1.8;
        }
        >.el-button{
          min-width: 5.9376vw;
  line-height: 1vw;

          position: absolute;
        }
      }
    }
    >div:hover{
      transform: scale(1.01);
      box-shadow: 0px 0px 1vw 1vw #eee;
    }
    > div:first-child {
      margin-top: -2.08vw;
    }
    .imgL {
      min-height: 13.28vw;
      > div {
        width: 63.54vw;
      }
      img {
        width: 10vw;
        height: 10vw;
      }
      .el-button {
        // position: absolute;
        right:1vw;
        bottom: 0;
      }
    }
    .imgR {
      min-height: 13.854vw;
      > div {
        width: 53.02vw;
      }
      .el-button {
        // position: absolute;
        bottom: 0px;
        right:1vw;
      }
      > img {
        width: 18.23vw;
        height: 10.625vw;
        position: absolute;
        right:1vw;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/product.vue